import React from 'react';
import {
	Control,
	FieldErrors,
	FieldValues,
	UseFormRegister,
	UseFormTrigger,
} from 'react-hook-form';

import { Button, GridContainer, Input, Select } from '@components/common';

import { ICountry } from '@interfaces/organisation/organisations';

import { addressAreas, fieldsToTestAddress, tabsNames } from '../constants';

import styles from './Address.module.scss';

interface IAddressProps {
	setCurrentTab: React.Dispatch<React.SetStateAction<string>>;
	isEditMode: boolean;
	countries: Array<ICountry>;
	register: UseFormRegister<FieldValues>;
	errors: FieldErrors;
	control: Control;
	trigger: UseFormTrigger<FieldValues>;
	isAddressTabError: boolean;
}

const Address = ({
	setCurrentTab,
	isEditMode,
	countries,
	register,
	errors,
	control,
	trigger,
	isAddressTabError,
}: IAddressProps) => {
	const onSubmit = async () => {
		const isValid = await trigger(fieldsToTestAddress);

		if (!isValid) return;

		if (!isEditMode) {
			setCurrentTab(tabsNames.organisationType);
		}
	};

	const onClickBackHandler = () => {
		setCurrentTab(tabsNames.basicInfo);
	};

	return (
		<div>
			<GridContainer
				columns={2}
				customClassName={styles.addressFormContainer}
				gap='15px 20px'
				gridTemplateAreas={addressAreas}
			>
				<div className={styles.property}>
					<Input
						errorMessage={errors?.property?.message}
						label='Property No./Name'
						name='property'
						placeholder='Enter property no./name'
						register={register}
					/>
				</div>
				<div className={styles.streetName}>
					<Input
						errorMessage={errors?.streetName?.message}
						label='Street Name'
						name='streetName'
						placeholder='Enter street name'
						register={register}
					/>
				</div>
				<div className={styles.locality}>
					<Input
						errorMessage={errors?.locality?.message}
						label='Locality'
						name='locality'
						placeholder='Enter locality'
						register={register}
					/>
				</div>
				<div className={styles.city}>
					<Input
						errorMessage={errors?.city?.message}
						label='Town/City'
						name='city'
						placeholder='Enter town/city'
						register={register}
					/>
				</div>
				<div className={styles.postcode}>
					<Input
						errorMessage={errors?.postcode?.message}
						label='Postcode'
						name='postcode'
						placeholder='Enter postcode'
						register={register}
						required
					/>
				</div>
				<div className={styles.country}>
					<Select
						control={control}
						errorMessage={errors.country?.message}
						isError={!!errors?.country}
						label='Country'
						menuPlacement='top'
						name='country'
						options={countries}
						placeholder='Select country'
						required
					/>
				</div>
				{!isEditMode
					&& <div className={styles.buttons}>
						<Button
							onClick={onClickBackHandler}
							text='Back'
							withoutBackground
						/>
						<Button
							disabled={isAddressTabError}
							onClick={onSubmit}
							text='Next'
						/>
					</div>
				}
			</GridContainer>
		</div>
	);
};

export default Address;
